import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Notifier from '../modules/notifier';
import MainContainer from '../modules/main-container';
import Login from '../modules/login';
import NotFound from '../modules/not-found';

const App = () => {
    return (
        <>
            <Notifier />
            <Switch>
                <Route path="/login-google" component={Login} />
                <Route path="/" component={MainContainer} />
                <Route component={NotFound} />
            </Switch>
        </>
    );
};

export default App;
